<div class="row">

  <div class="col-md-12">
      <div class="text-center">Copyright &copy;  2021 - FastSwiff. All Rights Reserved.</div>
    </div>
</div>